import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import {
  setAccountsByUserList,
  setAccountsList,
  setDefaultAccount,
} from "../../Redux/AccountSlice";
import { useSelector } from "react-redux";
import AccountService from "../../Services/http/AccountService";

export const getAccountList = async (dispatch) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.getAccountList();
  if (response && response["message"] === "success") {
    dispatch(setAccountsList(response["items"]));
  }
  dispatch(setIsActiveSpinner(false));
};

export const getAccountListByUser = async (dispatch, user_id) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.getAccountListByUser(user_id);
  if (response && response["message"] === "success") {
    dispatch(setAccountsByUserList(response["items"]));
  }
  dispatch(setIsActiveSpinner(false));
};

export const deleteAccount = async (dispatch, account_id) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.activeOrDeleteAccount(
    account_id,
    false
  );
  getAccountList(dispatch);
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
};

export const activeAccount = async (dispatch, account_id) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.activeOrDeleteAccount(
    account_id,
    true
  );
  getAccountList(dispatch);
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
};

export const getAccountDetails = async (dispatch, account_id) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.getAccountDetails(account_id);
  dispatch(setIsActiveSpinner(false));
  return response["account"];
};

export const changeDefaultAccount = (dispatch, account) => {
  dispatch(setDefaultAccount(account));
};

export const updateAccount = async (dispatch, accountId, accountData) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.updateAccount(
    accountId,
    accountData
  );
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
  return response;
};

export const addAccount = async (dispatch, accountData, user_id=null) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.addAccount(
    user_id,
    accountData
  );
  dispatch(setIsActiveSpinner(false));
  if (!response || response["message"] !== "success") {
    return {
      success: false,
      message: response?.message || "Failed to add account",
      code: response?.code || "unknown_error",
      error: response?.error || "unknown_error"
    };
  }
  getAccountListByUser(dispatch, user_id);
  return {
    success: true,
    message: "Account added successfully",
    code: null,
    error: null
  };
};

export const returnAddAccountIsAvailable = async (dispatch, user_id=null) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.returnAddAccountIsAvailable(
    user_id
  );
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
  return response["is_available"];
};